export default __webpack_public_path__ + "static/media/igi.862418a4.png";